import React from 'react';
import PropTypes from 'prop-types';
import StarRating from '../StarRating';
import i18n from '../../utils/i18n';
import withPlaceholder from '../withPlaceholder';

const MIN_EXCELLENT_RATING = 4.5;
const MIN_VERY_GOOD_RATING = 4.2;
const MIN_GOOD_RATING = 3.5;

const getDescriptionFromRating = (value) => {
  switch (true) {
    case value >= MIN_EXCELLENT_RATING:
      return ['excellent', i18n.gettext('rating.descriptiveText.excellent')];
    case value >= MIN_VERY_GOOD_RATING:
      return ['very-good', i18n.gettext('rating.descriptiveText.veryGood')];
    case value >= MIN_GOOD_RATING:
      return ['good', i18n.gettext('rating.descriptiveText.good')];
    default:
      return ['fair', ''];
  }
};

/**
 * Rating component to display restaurants rating as a star rating
 */

const RestaurantStarRating = ({
  value,
  count,
  hideDescriptiveText,
  isPlaceholder,
  placeholderClass,
}) => {
  // converting value from percentage until backend can do the work
  const rating = (Math.round((value / 20) * 10) / 10).toFixed(1);
  const displayRating = rating < MIN_GOOD_RATING ? `< ${MIN_GOOD_RATING}` : `${rating}`;
  const [band, description] = getDescriptionFromRating(rating);

  const props = {
    rating: displayRating,
    description: !hideDescriptiveText ? description : undefined,
    band,
    count,
    isPlaceholder,
    placeholderClass,
  };

  return <StarRating {...props} />;
};

RestaurantStarRating.propTypes = {
  /** Rating value */
  value: PropTypes.number.isRequired,
  /** Number of ratings  */
  count: PropTypes.string,
  /** Hide the text describing the rating */
  hideDescriptiveText: PropTypes.bool,
  /** Should the component be rendered as a placeholder for real content? */
  isPlaceholder: PropTypes.bool,
  /** (Only used internally by withPlaceholder, do not use) */
  placeholderClass: PropTypes.string,
};

RestaurantStarRating.defaultProps = {
  count: '',
  hideDescriptiveText: false,
  isPlaceholder: false,
  placeholderClass: '',
};

export const RestaurantStarRatingComponent = RestaurantStarRating;
export default withPlaceholder(RestaurantStarRating, { value: 4, count: '10' });
